// @flow

import React from 'react';
export function FilterIcon(props) {
  const { size = '0 0 16 16' } = props;

  return (
    <svg
      viewBox={size}
      className="Polaris-Icon__Svg icon-filter"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 0H1C0.4 0 0 0.4 0 1V3C0 3.3 0.1 3.6 0.4 3.8L6 8.5V15C6 15.4 6.2 15.8 6.6 15.9C6.7 16 6.9 16 7 16C7.3 16 7.5 15.9 7.7 15.7L9.7 13.7C9.9 13.5 10 13.3 10 13V8.5L15.6 3.8C15.9 3.6 16 3.3 16 3V1C16 0.4 15.6 0 15 0Z"
        fill={'#5C5F62'}
      />
    </svg>
  );
}
export function FilterIconDisable(props) {
  const { size = '0 0 16 16' } = props;
  const color = '#BABEC3';
  return (
    <svg
      viewBox={size}
      className="Polaris-Icon__Svg icon-filter"
      focusable="false"
      aria-hidden="true">
      <path
        d="M15 0H1C0.4 0 0 0.4 0 1V3C0 3.3 0.1 3.6 0.4 3.8L6 8.5V15C6 15.4 6.2 15.8 6.6 15.9C6.7 16 6.9 16 7 16C7.3 16 7.5 15.9 7.7 15.7L9.7 13.7C9.9 13.5 10 13.3 10 13V8.5L15.6 3.8C15.9 3.6 16 3.3 16 3V1C16 0.4 15.6 0 15 0Z"
        fill={color}
      />
    </svg>
  );
}
